import { BlobToUrlBaseValueConverter } from 'General/Resources/ValueConverters/BlobToUrlBase';
export class BlobToUrlValueConverter extends BlobToUrlBaseValueConverter {

}